/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Already_SyncedInputs */

const en_error_linesheet_already_synced = /** @type {(inputs: Error_Linesheet_Already_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The linesheet was already sent to Business Central: archive it instead.`)
};

/**
* | output |
* | --- |
* | "The linesheet was already sent to Business Central: archive it instead." |
*
* @param {Error_Linesheet_Already_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_already_synced = /** @type {((inputs?: Error_Linesheet_Already_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Already_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_already_synced(inputs)
});